// @flow

import * as React from 'react';
import {useLocation} from 'docs/data';
import {Executable} from './_executable';

const Brew = () => {
  const {pushLocation} = useLocation();

  React.useEffect(() => {
    pushLocation('/docs/stripe-cli?shell=true#install');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

// This executable is more of an alias which will essentially redirect
// the user to the Stripe CLI installation docs when they try using the
// `brew` command.
export class brew extends Executable {
  help() {
    this.setAllowInput(true);
    return 'package manager used to install the Stripe CLI on MacOS';
  }

  run() {
    this.setAllowInput(true);
    return <Brew />;
  }
}
